// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { ApiError, AuditEvent, AuditEventList } from '../models/index';
import {
  ApiErrorFromJSON,
  ApiErrorToJSON,
  AuditEventFromJSON,
  AuditEventToJSON,
  AuditEventListFromJSON,
  AuditEventListToJSON,
} from '../models/index';

export interface V1AuditEventsIdGetRequest {
  id: number;
}

export interface V1ClustersIdAuditEventsGetRequest {
  id: string;
  actor?: string;
  onBehalfOf?: string;
  action?: string;
  operation?: V1ClustersIdAuditEventsGetOperationEnum;
  since?: string;
  until?: string;
  limit?: number;
  pageToken?: string;
}

export interface V1EnvironmentsEnvironmentAuditEventsGetRequest {
  environment: string;
  entityKind?: V1EnvironmentsEnvironmentAuditEventsGetEntityKindEnum;
  entityId?: string;
  entityName?: string;
  actor?: string;
  onBehalfOf?: string;
  action?: string;
  operation?: V1EnvironmentsEnvironmentAuditEventsGetOperationEnum;
  since?: string;
  until?: string;
  limit?: number;
  pageToken?: string;
}

export interface V1IsolationUnitsIdAuditEventsGetRequest {
  id: string;
  actor?: string;
  onBehalfOf?: string;
  action?: string;
  operation?: V1IsolationUnitsIdAuditEventsGetOperationEnum;
  since?: string;
  until?: string;
  limit?: number;
  pageToken?: string;
}

export interface V1PartitionsIdAuditEventsGetRequest {
  id: string;
  actor?: string;
  onBehalfOf?: string;
  action?: string;
  operation?: V1PartitionsIdAuditEventsGetOperationEnum;
  since?: string;
  until?: string;
  limit?: number;
  pageToken?: string;
}

/**
 *
 */
export class AuditApi extends runtime.BaseAPI {
  /**
   * Get an audit event
   */
  async v1AuditEventsIdGetRaw(
    requestParameters: V1AuditEventsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AuditEvent>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1AuditEventsIdGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/audit-events/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      AuditEventFromJSON(jsonValue),
    );
  }

  /**
   * Get an audit event
   */
  async v1AuditEventsIdGet(
    requestParameters: V1AuditEventsIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AuditEvent> {
    const response = await this.v1AuditEventsIdGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Changes to one cluster, newest first. Works after the cluster is deleted.
   * List a cluster\'s audit events
   */
  async v1ClustersIdAuditEventsGetRaw(
    requestParameters: V1ClustersIdAuditEventsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AuditEventList>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1ClustersIdAuditEventsGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['actor'] != null) {
      queryParameters['actor'] = requestParameters['actor'];
    }

    if (requestParameters['onBehalfOf'] != null) {
      queryParameters['on_behalf_of'] = requestParameters['onBehalfOf'];
    }

    if (requestParameters['action'] != null) {
      queryParameters['action'] = requestParameters['action'];
    }

    if (requestParameters['operation'] != null) {
      queryParameters['operation'] = requestParameters['operation'];
    }

    if (requestParameters['since'] != null) {
      queryParameters['since'] = requestParameters['since'];
    }

    if (requestParameters['until'] != null) {
      queryParameters['until'] = requestParameters['until'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['pageToken'] != null) {
      queryParameters['page_token'] = requestParameters['pageToken'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/clusters/{id}/audit-events`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      AuditEventListFromJSON(jsonValue),
    );
  }

  /**
   * Changes to one cluster, newest first. Works after the cluster is deleted.
   * List a cluster\'s audit events
   */
  async v1ClustersIdAuditEventsGet(
    requestParameters: V1ClustersIdAuditEventsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AuditEventList> {
    const response = await this.v1ClustersIdAuditEventsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Changes to the environment\'s catalog entities, newest first. Filters combine with AND. Follow next_page_token for older events.
   * List an environment\'s audit events
   */
  async v1EnvironmentsEnvironmentAuditEventsGetRaw(
    requestParameters: V1EnvironmentsEnvironmentAuditEventsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AuditEventList>> {
    if (requestParameters['environment'] == null) {
      throw new runtime.RequiredError(
        'environment',
        'Required parameter "environment" was null or undefined when calling v1EnvironmentsEnvironmentAuditEventsGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['entityKind'] != null) {
      queryParameters['entity_kind'] = requestParameters['entityKind'];
    }

    if (requestParameters['entityId'] != null) {
      queryParameters['entity_id'] = requestParameters['entityId'];
    }

    if (requestParameters['entityName'] != null) {
      queryParameters['entity_name'] = requestParameters['entityName'];
    }

    if (requestParameters['actor'] != null) {
      queryParameters['actor'] = requestParameters['actor'];
    }

    if (requestParameters['onBehalfOf'] != null) {
      queryParameters['on_behalf_of'] = requestParameters['onBehalfOf'];
    }

    if (requestParameters['action'] != null) {
      queryParameters['action'] = requestParameters['action'];
    }

    if (requestParameters['operation'] != null) {
      queryParameters['operation'] = requestParameters['operation'];
    }

    if (requestParameters['since'] != null) {
      queryParameters['since'] = requestParameters['since'];
    }

    if (requestParameters['until'] != null) {
      queryParameters['until'] = requestParameters['until'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['pageToken'] != null) {
      queryParameters['page_token'] = requestParameters['pageToken'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/environments/{environment}/audit-events`;
    urlPath = urlPath.replace(
      `{${'environment'}}`,
      encodeURIComponent(String(requestParameters['environment'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      AuditEventListFromJSON(jsonValue),
    );
  }

  /**
   * Changes to the environment\'s catalog entities, newest first. Filters combine with AND. Follow next_page_token for older events.
   * List an environment\'s audit events
   */
  async v1EnvironmentsEnvironmentAuditEventsGet(
    requestParameters: V1EnvironmentsEnvironmentAuditEventsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AuditEventList> {
    const response = await this.v1EnvironmentsEnvironmentAuditEventsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Changes to one isolation unit, newest first. Works after the isolation unit is deleted.
   * List an isolation unit\'s audit events
   */
  async v1IsolationUnitsIdAuditEventsGetRaw(
    requestParameters: V1IsolationUnitsIdAuditEventsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AuditEventList>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1IsolationUnitsIdAuditEventsGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['actor'] != null) {
      queryParameters['actor'] = requestParameters['actor'];
    }

    if (requestParameters['onBehalfOf'] != null) {
      queryParameters['on_behalf_of'] = requestParameters['onBehalfOf'];
    }

    if (requestParameters['action'] != null) {
      queryParameters['action'] = requestParameters['action'];
    }

    if (requestParameters['operation'] != null) {
      queryParameters['operation'] = requestParameters['operation'];
    }

    if (requestParameters['since'] != null) {
      queryParameters['since'] = requestParameters['since'];
    }

    if (requestParameters['until'] != null) {
      queryParameters['until'] = requestParameters['until'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['pageToken'] != null) {
      queryParameters['page_token'] = requestParameters['pageToken'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/isolation-units/{id}/audit-events`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      AuditEventListFromJSON(jsonValue),
    );
  }

  /**
   * Changes to one isolation unit, newest first. Works after the isolation unit is deleted.
   * List an isolation unit\'s audit events
   */
  async v1IsolationUnitsIdAuditEventsGet(
    requestParameters: V1IsolationUnitsIdAuditEventsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AuditEventList> {
    const response = await this.v1IsolationUnitsIdAuditEventsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Changes to one partition, newest first. Works after the partition is deleted.
   * List a partition\'s audit events
   */
  async v1PartitionsIdAuditEventsGetRaw(
    requestParameters: V1PartitionsIdAuditEventsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AuditEventList>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1PartitionsIdAuditEventsGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['actor'] != null) {
      queryParameters['actor'] = requestParameters['actor'];
    }

    if (requestParameters['onBehalfOf'] != null) {
      queryParameters['on_behalf_of'] = requestParameters['onBehalfOf'];
    }

    if (requestParameters['action'] != null) {
      queryParameters['action'] = requestParameters['action'];
    }

    if (requestParameters['operation'] != null) {
      queryParameters['operation'] = requestParameters['operation'];
    }

    if (requestParameters['since'] != null) {
      queryParameters['since'] = requestParameters['since'];
    }

    if (requestParameters['until'] != null) {
      queryParameters['until'] = requestParameters['until'];
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['pageToken'] != null) {
      queryParameters['page_token'] = requestParameters['pageToken'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/partitions/{id}/audit-events`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      AuditEventListFromJSON(jsonValue),
    );
  }

  /**
   * Changes to one partition, newest first. Works after the partition is deleted.
   * List a partition\'s audit events
   */
  async v1PartitionsIdAuditEventsGet(
    requestParameters: V1PartitionsIdAuditEventsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AuditEventList> {
    const response = await this.v1PartitionsIdAuditEventsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}

/**
 * @export
 */
export const V1ClustersIdAuditEventsGetOperationEnum = {
  Create: 'create',
  Update: 'update',
  Delete: 'delete',
} as const;
export type V1ClustersIdAuditEventsGetOperationEnum =
  (typeof V1ClustersIdAuditEventsGetOperationEnum)[keyof typeof V1ClustersIdAuditEventsGetOperationEnum];
/**
 * @export
 */
export const V1EnvironmentsEnvironmentAuditEventsGetEntityKindEnum = {
  Cluster: 'cluster',
  Partition: 'partition',
  IsolationUnit: 'isolation_unit',
} as const;
export type V1EnvironmentsEnvironmentAuditEventsGetEntityKindEnum =
  (typeof V1EnvironmentsEnvironmentAuditEventsGetEntityKindEnum)[keyof typeof V1EnvironmentsEnvironmentAuditEventsGetEntityKindEnum];
/**
 * @export
 */
export const V1EnvironmentsEnvironmentAuditEventsGetOperationEnum = {
  Create: 'create',
  Update: 'update',
  Delete: 'delete',
} as const;
export type V1EnvironmentsEnvironmentAuditEventsGetOperationEnum =
  (typeof V1EnvironmentsEnvironmentAuditEventsGetOperationEnum)[keyof typeof V1EnvironmentsEnvironmentAuditEventsGetOperationEnum];
/**
 * @export
 */
export const V1IsolationUnitsIdAuditEventsGetOperationEnum = {
  Create: 'create',
  Update: 'update',
  Delete: 'delete',
} as const;
export type V1IsolationUnitsIdAuditEventsGetOperationEnum =
  (typeof V1IsolationUnitsIdAuditEventsGetOperationEnum)[keyof typeof V1IsolationUnitsIdAuditEventsGetOperationEnum];
/**
 * @export
 */
export const V1PartitionsIdAuditEventsGetOperationEnum = {
  Create: 'create',
  Update: 'update',
  Delete: 'delete',
} as const;
export type V1PartitionsIdAuditEventsGetOperationEnum =
  (typeof V1PartitionsIdAuditEventsGetOperationEnum)[keyof typeof V1PartitionsIdAuditEventsGetOperationEnum];
